import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { SortValue, SortField } from "../types";

interface SortRowProps {
  sort: SortValue;
  fields: SortField[];
  usedFields: string[];
  onUpdate: (sort: SortValue) => void;
  onRemove: () => void;
}

export function SortRow({
  sort,
  fields,
  usedFields,
  onUpdate,
  onRemove,
}: SortRowProps) {
  const availableFields = fields.filter(
    (field) => field.id === sort.field || !usedFields.includes(field.id)
  );

  return (
    <div className="aero:flex aero:items-center aero:gap-2">
      <Select
        value={sort.field}
        onValueChange={(value) => onUpdate({ ...sort, field: value })}
      >
        <SelectTrigger className="aero:h-10 aero:flex-1 aero:min-w-0 aero:rounded aero:border-neutral-300">
          <SelectValue placeholder="Select Field" />
        </SelectTrigger>
        <SelectContent>
          {availableFields.map((field) => (
            <SelectItem key={field.id} value={field.id}>
              {field.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={sort.direction}
        onValueChange={(value) =>
          onUpdate({ ...sort, direction: value as "asc" | "desc" })
        }
      >
        <SelectTrigger className="aero:h-10 aero:flex-1 aero:min-w-0 aero:rounded aero:border-neutral-300">
          <SelectValue placeholder="Direction" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="asc">Ascending</SelectItem>
          <SelectItem value="desc">Descending</SelectItem>
        </SelectContent>
      </Select>

      <Button
        type="button"
        intent="destructive"
        design="outline"
        size="iconMd"
        onClick={onRemove}
      >
        <X className="aero:h-5 aero:w-5" />
      </Button>
    </div>
  );
}
